"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _AutoIntl = _interopRequireDefault(require("../elements/AutoIntl"));
var _ga = require("../../utils/ga");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const JSON_RE = /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g;
class JsonData extends _react.default.Component {
  static propTypes = {
    data: T.oneOfType([T.object, T.array, T.string]).isRequired,
    keyClassName: T.string,
    valueClassName: T.string
  };
  formatSyntax(json, keyClassName, valueClassName) {
    let html = /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      tag: "span",
      displayId: 'au.jsonViewer.genericError'
    });
    if (json) {
      if (typeof json != 'string') {
        json = (0, _stringify.default)(json, null, 2);
      }
      try {
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        html = json.replace(JSON_RE, function (match) {
          let cls = (0, _classnames.default)(valueClassName);
          if (/^"/.test(match) && /:$/.test(match)) {
            cls = (0, _classnames.default)(keyClassName);
          }
          return `<span class="${cls}">${match}</span>`;
        });
      } catch (error) {
        // we couldn't process the data provided
        (0, _ga.trackException)(error);
      }
    }
    return {
      __html: _dompurify.default.sanitize(html)
    };
  }
  render() {
    const {
      data,
      keyClassName,
      valueClassName
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("pre", null, /*#__PURE__*/_react.default.createElement("code", {
      dangerouslySetInnerHTML: this.formatSyntax(data, keyClassName, valueClassName)
    }));
  }
}
exports.default = JsonData;